import React from 'react';
import PropTypes from 'prop-types';
import { Radio, Typography } from '@mui/material';

import { getInsCategoryImg } from '../navMenuUtils';

import {
  StyledNavMenuSelectCustomerContainer,
  StyledNavMenuSelectCustomerTextContent,
  StyledNavMenuSelectCustomerPolicyLogo,
} from './NavMenuSelectCustomer.styled';

function NavMenuSelectCustomer(props) {
  const {
    customerKey,
    radioGroupName,
    policyName,
    customerName,
    insuranceCategory,
    isCurrentCustomer,
    contractEnded,
    disabled,
    handleSelectCustomer,
    tabIndex,
  } = props;

  return (
    <StyledNavMenuSelectCustomerContainer contractEnded={contractEnded}>
      <StyledNavMenuSelectCustomerPolicyLogo
        src={getInsCategoryImg(insuranceCategory)}
        alt={customerName}
      />

      <StyledNavMenuSelectCustomerTextContent>
        <Typography variant="h3">{customerName}</Typography>
        <Typography variant="p">{policyName}</Typography>
      </StyledNavMenuSelectCustomerTextContent>

      <Radio
        tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
        checked={isCurrentCustomer}
        value={customerKey}
        name={radioGroupName}
        disabled={disabled}
        onChange={handleSelectCustomer}
        slotProps={{
          input: {
            'aria-label': `${customerName} - ${policyName}`,
          },
        }}
      />
    </StyledNavMenuSelectCustomerContainer>
  );
}

export default NavMenuSelectCustomer;

NavMenuSelectCustomer.defaultProps = {
  isCurrentCustomer: false,
};

NavMenuSelectCustomer.defaultProps = {
  policyName: PropTypes.string,
  customerName: PropTypes.string,
  insuranceCategory: PropTypes.string,
  isCurrentCustomer: PropTypes.bool,
};
